import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_FundusAbnormal_FundusChecklist({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const formatDetail = (data) => {
      if (!data) return null;

      return data.map((item) => ({
        ...item,
        篩檢日期: item["篩檢日期"]
          ? moment(item["篩檢日期"]).format("YYYY-MM-DD")
          : "-",
        建案日期: item["建案日期"]
          ? moment(item["建案日期"]).format("YYYY-MM-DD")
          : "-",
        生日: item["生日"] ? moment(item["生日"]).format("YYYY-MM-DD") : "-",
      }));
    };

    setTbData({
      raw: formatDetail(apiData),
      format: null,
      export: formatDetail(exportData),
      totalRecord,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isPaginator: true,
        callMainAPI,
      })}
    </>
  );
}
